import styles from '../Styles/Reservations.module.css';

const getCompanyColor = (companyId) => {
    switch (companyId) {
        case "As Oy Tuusulan Metsänkuningas":
            return "#286e34";
        case "As Oy Tuusulan Mesikämmen":
            return "#6c2b29";
        case "Puistokulma-Säätiö sr":
            return "#221831";
        default:
            return "#000000"; // Oletusväri, jos talonyhtiölle ei ole määritelty erillistä väriä
    }
};

const validateUserForm = (formDetails) => {
  const { etunimi, sukunimi, osoite, postinumero, postitoimipaikka, puhelin, sähköposti } = formDetails;
  const newErrors = {};
  const postalCodePattern = /^[0-9]{5}$/; // Suomalaisen postinumeron regex
  const phonePattern = /^[+]?[0-9]{7,15}$/; // Yksinkertainen puhelinnumeron regex
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Yksinkertainen sähköpostiosoitteen regex
  if (!etunimi) newErrors.etunimi = 'Etunimi on pakollinen';
  if (!sukunimi) newErrors.sukunimi = 'Sukunimi on pakollinen';
  if (!osoite) newErrors.osoite = 'Osoite on pakollinen';
  if (!postinumero) {
    newErrors.postinumero = 'Postinumero on pakollinen';
  } else if (!postalCodePattern.test(postinumero)) {
    newErrors.postinumero = 'Postinumeron tulee olla 5 numeroa';
  }
  if (!postitoimipaikka) newErrors.postitoimipaikka = 'Postitoimipaikka on pakollinen';
  if (!puhelin) {
    newErrors.puhelin = 'Puhelinnumero on pakollinen';
  } else if (!phonePattern.test(puhelin)) {
    newErrors.puhelin = 'Puhelinnumero on virheellinen';
  }
  if (!sähköposti) {
    newErrors.sähköposti = 'Sähköpostiosoite on pakollinen';
  } else if (!emailPattern.test(sähköposti)) {
    newErrors.sähköposti = 'Sähköpostiosoite on virheellinen';
  }
  return {
    isValid: Object.keys(newErrors).length === 0,
    newErrors,
    errorMessages: Object.values(newErrors),
  };
};

const getSpaceImageClass = (spaceId) => {
  if(spaceId === 'NT4wTSfcKZt2Dq4ZDfHc') {
    return styles.imagesauna; 
  } else if(spaceId === 'AyaJrVOusUQRpBdRQRF4') {
    return styles.imageetatyo;
  }
  return styles.imagesauna;
};

const getResizedImage = (file, maxWidth, maxHeight, quality) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = URL.createObjectURL(file);
    image.onload = () => {
      let width = image.width;
      let height = image.height;
      if (width > height) {
        if (width > maxWidth) {
          height = height * (maxWidth / width);
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width = width * (maxHeight / height);
          height = maxHeight;
        }
      }
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(image, 0, 0, width, height);
      canvas.toBlob(resolve, 'image/jpeg', quality);
    };
    image.onerror = reject;
  });
}

// Yhdenmukaista aikaleima -> millisekunteihin
export const toMillis = (v) => {
  if (!v) return 0;

  // Numero: tunnista ms vs s järkevällä kynnyksellä
  if (typeof v === 'number') {
    // > 1e12 ~ ms (vuodet 2001–33658), 1e9–1e12 ~ sekuntit
    if (v > 1e12) return v;            // millisekunnit
    if (v > 1e9)  return v * 1000;     // sekunnit -> ms
    return 0;                           // liian pieni ollakseen ts
  }

  // ISO-string tms.
  if (typeof v === 'string') {
    const t = Date.parse(v);
    return Number.isNaN(t) ? 0 : t;
  }

  if (v instanceof Date) return v.getTime();

  // Firestore Timestamp (SDK-olio)
  if (v && typeof v.toMillis === 'function') return v.toMillis();

  // Firestore serialisoitu muoto
  if (v && typeof v.seconds === 'number')    return v.seconds * 1000;
  if (v && typeof v._seconds === 'number')   return v._seconds * 1000;

  return 0;
};

export const getTimeButtonLabel = (creationTime) => {
  const ms = toMillis(creationTime);
  if (!ms) return '';

  // Estä tulevaisuuteen lipsahtaneet ajat sotkemasta logiikkaa
  const now = Date.now();
  const diffMs = Math.max(0, now - ms);
  const hours = diffMs / (1000 * 60 * 60);
  if (hours <= 24)  return 'Uusi 24 h';
  if (hours <= 48)  return 'Uusi 48 h';
  if (hours <= 168) return 'Uusi 7 vrk ';
  if (hours <= 336) return 'Uusi 14 vrk';
  if (hours <= 720) return 'Uusi 1 kk';
  if (hours <= 2160) return 'Uusi 3 kk';

  return '';
};

const isUserInTargetGroup = (a, user) => {
  const roles = (user?.userRoles || []).map(r => (r.role || '').toLowerCase());
  if (roles.length === 0) 
    return true;
  if (roles.includes('hallitus') || roles.includes('isännöitsijä')) 
    return true;
  const target = String(a?.audience || a?.kohderyhmä || '').toLowerCase();
  if (!target) 
    return true;
  const isOwner = roles.includes('osakas');
  const isResident = roles.includes('asukas');
  if (isOwner && (target.includes('residents_owners') || target.includes('owners'))) 
    return true;
  if (isResident && target.includes('residents')) 
    return true;
  return false;
};


const getSaunaAvailability = (weekDay, hour) => {
    const saunaAvailability = {
      "perjantaina": [{ start: 19, end: 22 }],
      "lauantaina": [{ start: 19, end: 22 }],
      "sunnuntaina": [{ start: 19, end: 21 }]
    };
    console.log("checkSaunaAvailability: " + weekDay + " " + hour); 
    const availableTimes = saunaAvailability[weekDay];
    if (!availableTimes) return false;
    return availableTimes.some(time => hour >= time.start && hour < time.end);
}

export default {
    getCompanyColor,
    validateUserForm,
    getSpaceImageClass, 
    getResizedImage, 
    toMillis,
    getTimeButtonLabel,
    isUserInTargetGroup,
    getSaunaAvailability
};